// extracted by mini-css-extract-plugin
module.exports = {"upperHeading":"Blogs_upperHeading__2sHpW","mainHeading":"Blogs_mainHeading__3Hz9c","subHeading":"Blogs_subHeading__mISDc","blogFlex":"Blogs_blogFlex__WhmIC"};